import { Filter } from './filter';
import { Level } from './level';
import { LogRecord } from './log-record';

export abstract class LogHandler {
  level: Level = Level.ALL;
  private filter: Filter | null = null;

  abstract publish(record: LogRecord): void;

  setFilter(filter: Filter | null): void {
    this.filter = filter;
  }

  getFilter(): Filter | null {
    return this.filter;
  }

  getLevel(): Level {
    return this.level;
  }

  setLevel(level: Level): void {
    this.level = level;
  }

  isLoggable = (record: LogRecord): boolean => {
    if (record.level < this.level || this.level === Level.OFF) {
      return false;
    }
    return this.filter === null ? true : this.filter.isLoggable(record);
  };
}
